import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    // CONTAINERS
    "PoiContainer": () => import("./components/PoiContainer.vue"),

    "AllPointOfInterest": () => import("./components/tiles/poi/AllPointOfInterest.vue"),
    "AllPoiMapTile": () => import("./components/tiles/poi/AllPoiMapTile.vue"),

    // EDIT
    "EditPoiContainer": () => import("./components/tiles/edit/EditPoiContainer.vue"),
    "EditPoiInfo": () => import("./components/tiles/edit/EditPoiInfo.vue"),
    "EditPoiMap": () => import("./components/tiles/edit/EditPoiMap.vue"),

};


export default globals;
